'use client';

import { useState } from 'react';
import { Plus } from 'lucide-react';
import { AdminModal } from '@/components/admin/AdminModal';
import { useToast } from '@/components/admin/Toast';

type Props = {
  open: boolean;
  onClose: () => void;
  onCreated: () => void;
};

export function CreateTenantModal({ open, onClose, onCreated }: Props) {
  const { toast } = useToast();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    name: '',
    slug: '',
    city: '',
    phone: '',
    email: '',
    admin_name: '',
    admin_email: '',
    plan_slug: 'starter',
    seed_menu: true,
    communications_account_id: '',
  });

  const submit = async () => {
    setSaving(true);
    const res = await fetch('/api/super-admin/tenants', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    setSaving(false);
    if (res.ok) {
      const data = await res.json().catch(() => ({}));
      toast(data.email_sent === false ? data.warning : 'Tenant criado e convite enviado ao administrador', data.email_sent === false ? 'error' : 'success');
      onCreated();
      onClose();
      setForm({
        name: '', slug: '', city: '', phone: '', email: '',
        admin_name: '', admin_email: '',
        plan_slug: 'starter', seed_menu: true, communications_account_id: '',
      });
    } else {
      const data = await res.json().catch(() => ({}));
      toast(data.error || 'Erro ao criar tenant', 'error');
    }
  };

  return (
    <AdminModal
      open={open}
      onClose={onClose}
      title="Novo tenant"
      description="Cria restaurante, dominio, admin e menu base"
      size="xl"
      footer={
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="btn btn-secondary btn-sm">Cancelar</button>
          <button type="button" onClick={submit} disabled={saving} className="btn btn-sm bg-brand text-white">
            <Plus className="w-4 h-4" /> Criar tenant
          </button>
        </div>
      }
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input className="input-field" placeholder="Nome do restaurante" value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value, slug: form.slug || e.target.value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '') })} />
        <input className="input-field font-mono" placeholder="slug (ex: meu-restaurante)" value={form.slug}
          onChange={(e) => setForm({ ...form, slug: e.target.value.toLowerCase() })} />
        <input className="input-field" placeholder="Cidade" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
        <input className="input-field" placeholder="Telefone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        <input className="input-field sm:col-span-2" placeholder="Email do restaurante" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        <hr className="sm:col-span-2 border-surface-3" />
        <input className="input-field" placeholder="Nome do admin" value={form.admin_name} onChange={(e) => setForm({ ...form, admin_name: e.target.value })} />
        <input className="input-field" placeholder="Email admin" value={form.admin_email}
          onChange={(e) => setForm({ ...form, admin_email: e.target.value })} />
        <p className="sm:col-span-2 text-xs text-ink-500">O administrador recebe um link individual para definir a palavra-passe no primeiro acesso.</p>
        <input
          className="input-field font-mono sm:col-span-2"
          placeholder="Account UUID do telephony-core (opcional nesta fase)"
          value={form.communications_account_id}
          onChange={(e) => setForm({ ...form, communications_account_id: e.target.value.trim() })}
        />
        <select className="input-field" value={form.plan_slug} onChange={(e) => setForm({ ...form, plan_slug: e.target.value })}>
          <option value="starter">Starter</option>
          <option value="pro">Pro</option>
          <option value="enterprise">Enterprise</option>
        </select>
        <label className="flex items-center gap-2 text-sm text-ink-600">
          <input type="checkbox" checked={form.seed_menu} onChange={(e) => setForm({ ...form, seed_menu: e.target.checked })} />
          Criar menu base (3 pratos)
        </label>
      </div>
    </AdminModal>
  );
}
